module.exports = __webpack_public_path__ + "assets/img/block-left-4a5db4f6.png";